import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio, Select, MenuItem, Paper } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import { useEffect } from "react";
import Uploader from "src/components/uploader/Uploader";
import MyEditor from "src/components/editor/MyEditor";

const NoticeEditDialog = ({ action, row, open, onClose, onFinish }) => {
  const [detail, setDetail] = useState(row.detail);

  const [form, setForm] = useState({
    title: row.title || "",
    subtitle: row.subtitle || "",
    cover: row.cover || "",
    isShow: row.isShow != undefined ? (row.isShow ? 1 : 0) : 1,
  });

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    const formData = {
      ...form,
      detail,
    };

    if (action == "edit") {
      formData.id = row.id;
    }
    const { msg } = await asyncRequest({
      path: action == "add" ? "/notice/add" : "/notice/edit",
      data: formData,
    });

    alert(msg, "success");
    onFinish();
  }

  return (
    <FormDialog title="添加公告" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="标题" required>
        <TextField fullWidth placeholder="请输入标题" autoComplete="off" id="title" value={form.title} size="small" onChange={(e) => handleIptChange("title", e.target.value)} />
      </FormItem>

      <FormItem title="封面">
        <Uploader images={form.cover} onUploaded={(v) => handleIptChange("cover", v)} />
      </FormItem>

      <FormItem title="状态" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
          <FormControlLabel value={0} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          <FormControlLabel value={1} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
        </RadioGroup>
      </FormItem>

      <FormItem title="摘要">
        <TextField fullWidth placeholder="请输入摘要，不填写可能选取正文前20个文字" autoComplete="off" id="subtitle" value={form.subtitle} size="small" onChange={(e) => handleIptChange("subtitle", e.target.value)} />
      </FormItem>

      <FormItem title="内容" required>
        <Paper variant="outlined" sx={{ paddingX: 2, paddingY: 1, flex: 1, minHeight: 220 }}>
          <MyEditor
            html={detail}
            onChange={(val) => {
              setDetail(val);
            }}
          />
        </Paper>
      </FormItem>
    </FormDialog>
  );
};

export default NoticeEditDialog;
